function stripPhone(phone) {
  return phone.replace(/[^0-9+]/u, '')
}

export { stripPhone }
